import { render } from "./PremiumTransactionDetailsModal.vue?vue&type=template&id=23d20799&scoped=true"
import script from "./PremiumTransactionDetailsModal.vue?vue&type=script&lang=js"
export * from "./PremiumTransactionDetailsModal.vue?vue&type=script&lang=js"

import "./PremiumTransactionDetailsModal.vue?vue&type=style&index=0&id=23d20799&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/CBHI/PONA HEALTH/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23d20799"]])

export default __exports__